module.exports = __webpack_public_path__ + "img/7c48bb34a95e3a9c2b94469bcc800f22.png";